<template>
  <section class="summaryItem">
    <header class="header">
      <h2>{{ $t(`summary.${config.label}`) }}</h2>
      <button class="editButton" type="button" @click="toggleEdit">
        <chevron-up-icon v-if="isEditMode" :width="24" :height="24" />
        <edit-icon v-else :width="22" :height="22" />
      </button>
    </header>
    <div v-if="isEditMode" class="editForm">
      <slot />
    </div>
    <div v-else>
      <summary-item-entries :entries="usedSummaryItems" />
    </div>
  </section>
</template>

<script>
import { getCurrentInstance } from '@nuxtjs/composition-api'
import ChevronUpIcon from '~/components/icons/ChevronUpIcon'
import EditIcon from '~/components/icons/EditIcon'
import SummaryItemEntries from './SummaryItemEntries'

export default {
  name: 'DXSummaryAdapter',
  components: {
    ChevronUpIcon,
    EditIcon,
    SummaryItemEntries,
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
    isEditMode: {
      type: Boolean,
      required: true,
    },
    summaryItems: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    // Start with edit mode
    getCurrentInstance().emit('editMode', true)
  },
  computed: {
    filteredItemIds() {
      return this.config.shownItemIds.filter(
        (id) =>
          !(
            this.summaryItems[id].__typename === 'ModuleSelectionField' && // eslint-disable-line no-underscore-dangle
            !this.summaryItems[id].value
          ),
      )
    },
    usedSummaryItems() {
      return this.filteredItemIds.map((id) => this.summaryItems[id])
    },
  },
  methods: {
    toggleEdit() {
      this.$emit('editMode', !this.isEditMode)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/colors';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/variables/typo';
@import '~@sumcumo/dextra-frontend-component-lib/dist/assets/styles/functions/px-to-rem';

.summaryItem {
  padding: rem(12) rem(20);

  @include media-breakpoint-up(lg) {
    padding: rem(12) rem(60);
  }

  p {
    margin: 0;

    strong {
      font-family: $font-family-heavy;
    }
  }
}

.editForm {
  display: grid;
  margin-bottom: rem(12);
  border-bottom: 2px solid $black-clr;
  padding-bottom: rem(32);
  grid-gap: rem(16);
  grid-template-columns: 1fr;
}

.header {
  display: flex;
  margin-bottom: rem(12);
  border-bottom: 2px solid $black-clr;
  padding-bottom: rem(12);
  justify-content: space-between;
  align-items: center;

  @include media-breakpoint-up(lg) {
    margin-bottom: rem(16);
    padding-bottom: rem(16);
  }

  h2 {
    margin: 0;
    color: $black-clr;
    font-family: $font-family-heavy;
    font-size: rem(18);
    line-height: rem(20);

    @include media-breakpoint-up(lg) {
      font-size: rem(24);
      line-height: rem(28);
    }
  }
}

.editButton {
  margin-left: rem(16);
  border: none;
  padding: 0 rem(8);
  background: transparent;
  color: $color-turquoise-surf;
  outline: none;
}
</style>
